import { render, staticRenderFns } from "./CAForm.vue?vue&type=template&id=335cea9d&"
import script from "./CAForm.vue?vue&type=script&lang=js&"
export * from "./CAForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335cea9d')) {
      api.createRecord('335cea9d', component.options)
    } else {
      api.reload('335cea9d', component.options)
    }
    module.hot.accept("./CAForm.vue?vue&type=template&id=335cea9d&", function () {
      api.rerender('335cea9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CAForm.vue"
export default component.exports